var updateQueryParams = function updateQueryParams(key, value, url) {
  if (!url) url = window.location.href;
  var re = new RegExp("([?&])".concat(key, "=.*?(&|#|$)(.*)"), "gi"),
      hash;

  if (re.test(url)) {
    if (typeof value !== 'undefined' && value !== null) return url.replace(re, "$1".concat(key, "=").concat(value, "$2$3"));else {
      hash = url.split('#');
      url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) url += "#".concat(hash[1]);
      return url;
    }
  } else {
    if (typeof value !== 'undefined' && value !== null) {
      var separator = url.indexOf('?') !== -1 ? '&' : '?';
      hash = url.split('#');
      url = "".concat(hash[0]).concat(separator).concat(key, "=").concat(value);
      if (typeof hash[1] !== 'undefined' && hash[1] !== null) url += "#".concat(hash[1]);
      return url;
    } else return url;
  }
};

var getQueryParam = function getQueryParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)")),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

var queryParamsToObject = function queryParamsToObject() {
  var search = window.location.search.substring(1);

  if (search.length === 0) {
    return {};
  } else {
    var result = JSON.parse("{\"".concat(search.replace(/&/g, '","').replace(/=/g, '":"'), "\"}"), function (key, value) {
      return key === "" ? value : decodeURIComponent(value);
    });
    return result;
  }
};

export default {
  updateQueryParams: updateQueryParams,
  getQueryParam: getQueryParam,
  queryParamsToObject: queryParamsToObject
};